import React from "react";
import useWindowDimensions from "../hooks/useWindowDimensions";
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import { SmallButton } from "./components/Buttons";
import Icon from "../components/Selfcare/Common/Icon";


export const ActionBox = (props) => {
    const wDim = useWindowDimensions();
    const theme = useTheme();
    return (
        <>
            <Grid item style={{ width: '100%', padding: '10px', marginBottom: '19px', borderRadius: '10px', backgroundColor: theme.palette.boxBackground.main, color: theme.palette.text.primary, cursor: 'pointer' }} onClick={() => props.action}>
                <div style={{ position: 'relative'}}>
                    <SmallButton style={{ position: 'absolute', top: '45px', right: '0px' }} onClick={props.action}>{props.buttonText}</SmallButton>
                </div>
                <div style={{ minHeight: '65px' }}>
                        <Icon name={props.icon} size={36} color={theme.palette.primary.main} style={{ display: 'inline-block' }}/>
                        <div style={{ display: 'inline-block', marginLeft: '10px' }}>
                            <div style={{ fontSize: '14px', fontWeight: 400 }}>{props.title}</div>
                        <div style={{ fontSize: '12px', fontWeight: 200, fontFamily: theme.typography.fontFamily2 }}>{props.subTitle}</div>
                    </div>
                </div>
            </Grid>
        </>
    );
};


